/** Full-page navigation to another origin; kept separate so tests can observe it. */
export function navigateTo(url: string): void {
  window.location.href = url;
}
